// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MimaDropzone_outline__EUb5X {
  width: 100%;
  border: 1px dashed var(--color-grey);
  min-height: 15rem;
  border-radius: 1rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: var(--default-font-small);
  margin-bottom: 0.5rem;
  cursor: pointer;
}

.MimaDropzone_group__8Xmr- {
  margin-bottom: 2rem;
}

.MimaDropzone_label__trfvB {
  font-size: var(--default-font-small);
  margin-bottom: 0.5rem;
  padding-left: 2rem;
  font-size: 1.4rem;
}

.MimaDropzone_upload__Mm\\+Bf {
  background-color: var(--color-primary-3);
  color: var(--color-dark);
  border-radius: 0.8rem;
  padding: 1rem;
}

.MimaDropzone_content__gq5j3 {
  width: 100%;
  border-radius: 1rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.MimaDropzone_preview__Qwyii {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  gap: 1rem;
}
.MimaDropzone_preview__Qwyii > * {
  position: relative;
  max-width: 100%;
}
.MimaDropzone_preview__Qwyii > * p {
  word-break: break-all;
}
.MimaDropzone_preview__Qwyii img {
  max-width: 100%;
  margin-bottom: 1rem;
  height: 10rem;
  object-fit: cover;
}

.MimaDropzone_remove__3Ba9q {
  position: absolute;
  color: var(--color-error);
  z-index: 2;
  font-size: 2.5rem;
  right: -1rem;
  top: -1rem;
  cursor: pointer;
  background-color: var(--color-white);
  border: none;
}
.MimaDropzone_remove__3Ba9q:hover {
  color: var(--color-deep-red);
}

.MimaDropzone_rejected__\\+Dy2f {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: var(--color-light-red);
  padding: 1rem;
  margin-top: 1rem;
}
.MimaDropzone_rejected__msg__V-Mtz {
  color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/MimaDropzone.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,oCAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AADF;;AAIA;EACE,wCAAA;EACA,wBAAA;EACA,qBAAA;EACA,aAAA;AADF;;AAIA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,qCAAA;EACA,WAAA;EACA,SAAA;AADF;AAGE;EACE,kBAAA;EACA,eAAA;AADJ;AAGI;EACE,qBAAA;AADN;AAKE;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,oCAAA;EACA,YAAA;AAJF;AAME;EACE,4BAAA;AAJJ;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wCAAA;EACA,aAAA;EACA,gBAAA;AALF;AAOE;EACE,yBAAA;AALJ","sourcesContent":["@import \"./variables/breakpoints\";\n\n.outline {\n  width: 100%;\n  border: 1px dashed var(--color-grey);\n  min-height: 15rem;\n  border-radius: 1rem;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: var(--default-font-small);\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n}\n\n.group {\n  margin-bottom: 2rem;\n}\n\n.label {\n  font-size: var(--default-font-small);\n  margin-bottom: 0.5rem;\n  padding-left: 2rem;\n  font-size: 1.4rem;\n}\n\n.upload {\n  background-color: var(--color-primary-3);\n  color: var(--color-dark);\n  border-radius: 0.8rem;\n  padding: 1rem;\n}\n\n.content {\n  width: 100%;\n  border-radius: 1rem;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.preview {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  width: 100%;\n  gap: 1rem;\n\n  &>* {\n    position: relative;\n    max-width: 100%;\n\n    p {\n      word-break: break-all;\n    }\n  }\n\n  img {\n    max-width: 100%;\n    margin-bottom: 1rem;\n    height: 10rem;\n    object-fit: cover;\n  }\n}\n\n.remove {\n  position: absolute;\n  color: var(--color-error);\n  z-index: 2;\n  font-size: 2.5rem;\n  right: -1rem;\n  top: -1rem;\n  cursor: pointer;\n  background-color: var(--color-white);\n  border: none;\n\n  &:hover {\n    color: var(--color-deep-red);\n  }\n}\n\n.rejected {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  background-color: var(--color-light-red);\n  padding: 1rem;\n  margin-top: 1rem;\n\n  &__msg {\n    color: var(--color-error);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outline": `MimaDropzone_outline__EUb5X`,
	"group": `MimaDropzone_group__8Xmr-`,
	"label": `MimaDropzone_label__trfvB`,
	"upload": `MimaDropzone_upload__Mm+Bf`,
	"content": `MimaDropzone_content__gq5j3`,
	"preview": `MimaDropzone_preview__Qwyii`,
	"remove": `MimaDropzone_remove__3Ba9q`,
	"rejected": `MimaDropzone_rejected__+Dy2f`,
	"rejected__msg": `MimaDropzone_rejected__msg__V-Mtz`
};
export default ___CSS_LOADER_EXPORT___;
